import React from 'react'
import './Bodysection2.css'
// import bodyimages1 from '../../../Home/images/pexels-pixabay-159711.jpg'
const Bodysection2 = () => {
  return (
    <div className='bodysection2'>
        <div className='bodyconatiner'>
            <div className='bodyconatiner1'> <hr />
            <div data-aos="fade-up"
     data-aos-duration="3000">

           <h1> Make Your Success a Priority. Be a PDMite</h1>
            <p>Become what you want to be.A place where learners become leaders.</p> 
            </div>
            <br /><br /> <hr /> <br />
            </div>
           
        </div>
 
    </div>
  )
}

export default Bodysection2
